import { call, put, select } from 'redux-saga/effects';
import { selectIsSystemSession } from 'features/application/selectors';
import { selectShowCaptionsInSystemSession } from 'features/layout/features/config/systemSessionSelectors';
import { announceTranscriptionLanguageSaga } from 'features/transcripts/sagas/announceTranscriptionLanguageSaga';
import {
  captionsToggled,
  selectSpokenLanguageOverridden,
} from 'features/transcripts/slices/captions/captionsSlice';

export function* onTranscriptionStartedSaga() {
  const isSystemSession: boolean = yield select(selectIsSystemSession);
  if (isSystemSession) {
    const showCaptions: boolean = yield select(selectShowCaptionsInSystemSession);
    if (showCaptions) {
      yield put(captionsToggled(true));
    }
  }

  // Nothing on the started event says what the session is transcribed in, so a participant who
  // picked their own language can only be told about their own speech.
  const spokenLanguageOverridden: boolean = yield select(selectSpokenLanguageOverridden);

  yield call(announceTranscriptionLanguageSaga, spokenLanguageOverridden ? 'personal' : 'session');
}
